import { ROUTES } from "constants/routes";
import { GESTION_ROUTES } from "constants/gestion-routes";

const GESTION_COMPETITION_PATH = /^\/admin\/gestion\/(\d+)\/competitions\/([^/]+)/;

export function resolveCompetitionAdminScope(pathname, params = {}) {
  const gestionMatch = pathname.match(GESTION_COMPETITION_PATH);
  if (gestionMatch) {
    return { customerId: gestionMatch[1], competitionId: gestionMatch[2] };
  }
  if (params.customerId && params.id && pathname.includes("/competitions/")) {
    return { customerId: String(params.customerId), competitionId: params.id };
  }
  return null;
}

export function buildCompetitionAdminRoutes(competitionId, customerId = null) {
  const base = customerId
    ? GESTION_ROUTES.competition(customerId, competitionId)
    : `${ROUTES.ADMIN.EVENT}/${competitionId}`;

  return {
    isGestionScope: Boolean(customerId),
    customerId,
    competitionId,
    overview: base,
    schedule: `${base}/schedule`,
    clubs: `${base}/clubs`,
    edit: `${base}/edit`,
    scheduling: `${base}/scheduling`,
    customFields: `${base}/custom-fields`,
    matchScoring: `${base}/match-scoring`,
    tournaments: `${base}/tournaments`,
    tournamentsCreate: `${base}/tournaments/create`,
    registrations: `${base}/registrations`,
    managers: `${base}/managers`,
  };
}

export function competitionAdminRoutesFromLocation(location, params = {}) {
  const scope = resolveCompetitionAdminScope(location.pathname, params);
  const competitionId = scope?.competitionId || params.id;
  if (!competitionId) {
    return buildCompetitionAdminRoutes(params.id);
  }
  return buildCompetitionAdminRoutes(competitionId, scope?.customerId ?? null);
}

export function competitionAdminRoutesFromMatch(match) {
  return competitionAdminRoutesFromLocation({ pathname: match.url || match.path || "" }, match.params);
}
